import {Component, EventEmitter, Input, isDevMode, OnInit, Output, ViewChild} from '@angular/core';

import {MatMenu} from '@angular/material/menu';
import {Router} from '@angular/router';
import {EMPTY, lastValueFrom} from 'rxjs';
import {Clipboard} from '@angular/cdk/clipboard';
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";

// QQQ
// import {MsalService} from '@azure/msal-angular';
// import exportFromJSON from 'export-from-json'
// import {AuthService} from 'src/app/services/auth.service';
// import {GeneralService} from "../../../services/crud/general.service";
// import {version} from '../../../version'

// import {DialogComponent} from "../dialog/dialog.component";
import {AppInfoComponent} from '../dialog/app-info/app-info.component';
import {CoreService} from '../../services/Core.service';


@Component({
	selector: 'app-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit
{
	@Input()
	pageTitle = '';
	@Input()
	version = '';
	@Input()
	actions: string[] = [];

	@ViewChild('account') public account!: MatMenu;

	@Output() onClickLogin: EventEmitter<any> = new EventEmitter();
	@Output() onClickInfo: EventEmitter<any> = new EventEmitter();
	@Output() onClickLogout: EventEmitter<any> = new EventEmitter();
	@Output() onClickLogo: EventEmitter<any> = new EventEmitter();
	@Output() toggleSidenav: EventEmitter<void> = new EventEmitter<void>();

	topBarTitle: string = '???';

	name: string | undefined;
	email: string | undefined;
	role: string | undefined;

	appName: string = '';  // app. name
	appVersion: string = ''; // app. version
	beVersion: string = ''; // backend version

	// refresh: boolean = false;

	// usr!: string;

	availableUserRoles: any[] = [];

	constructor(
		// private msalService: MsalService, // QQQ
		// private authService: AuthService,// QQQ
		// private generalService: GeneralService, // QQQ
		protected router: Router,
		private clipboard: Clipboard,
		private dialog: MatDialog,
		public translate: TranslateService,
		public cs: CoreService
	)
	{
	}

	public errorHandler = (error: any) =>
	{
		return EMPTY;
	};

	// asynchronous initializations go here
	ngOnInit(): void
	{
		this.topBarTitle = "";

		// this.role= this.availableUserRoles[0].name;
		// this.prev_role= this.role;

		// this.role = undefined;
		// this.role = "";
		// this.role = ((this.availableUserRoles as unknown) as string); // cast from any to string

		// set current role
		// this.cs.getAuthService().getUserRole().subscribe(value =>
		// {
		// 	this.role = value;
		// });

		// get username
		this.cs.getAuthService().getUserNameObs().subscribe( value => {
			this.name= value;
		});

		// get user email
		this.cs.getAuthService().getEmailObs().subscribe( value => {
			this.email= value;
		});

		// get available roles
		this.cs.getAuthService().getRolesObs().subscribe(values => {
			this.availableUserRoles = values;
		});

		// get current user role id
		this.cs.getAuthService().getUserRoleObs().subscribe(value => {
			this.role= value;
		})

		// get application name
		this.appName = this.cs.getAppInfo().getAppName();

		// get front-end version
		this.appVersion = this.cs.getAppInfo().getAppVersion();

		// get back-end version
		this.cs.getAppInfo().getBackendVersionObs().subscribe( value => {
			this.beVersion = value;
		});

		/*
		this.authService.emailObs.subscribe((email) =>
		{
			this.email = email;
		});
		this.authService.nameObs.subscribe((name) =>
		{
			this.name = name;
		});
		this.authService.roleObs.subscribe((role) =>
		{
			//console.log(role)
			this.role = role.trim();
			this.authService.getAvailableRole().subscribe({
				next: value =>
				{
					this.availableUserRoles = value.oContent.map(r =>
					{

						return {
							id: r.ROLE_ID,
							name: r.ROLE_NAME
						}
					});
				}
			});
		});
		*/
	}

	isDevMode()
	{
		return isDevMode();
	}

	login()
	{
		this.onClickLogin.emit();
	}

	userInfo()
	{
		this.onClickInfo.emit();
	}

	logout()
	{
		this.onClickLogout.emit();
	}

	onLogoClick()
	{
		this.onClickLogo.emit();
	}

	isActionPresent(action: string)
	{
		// if (action == 'user.settings.view')
		// 	return true;
		// else
		// 	return false;
		let present: boolean = false;

		// if (action == 'user.settings.view')
		if (this.actions.indexOf(action) > -1)
			present = true;

		return present;
	}

	// arrayFrom(string: string)
	// {
	// 	return Array.from(string)['0'] + Array.from(string)['1'];
	// }

	// event handler for right menu click
	onMenuClick()
	{
		this.toggleSidenav.emit();
	}

	copyToken(): void
	{
		/*
		lastValueFrom(
			this.msalService.acquireTokenSilent({
				scopes: ['openid', 'profile', 'User.Read', 'email']
			})
		).then((token) =>
		{
			this.clipboard.copy(token.idToken);
		});
		*/
		this.cs.getIdentityService().getUserIdentityTokenObs().subscribe( token => {
			this.clipboard.copy(token);
		})
	}

	// this is the handler for button 'info' inside right menu' dialog
	info()
	{
		/*
		this.generalService.getVersion().subscribe(res =>
		{
			this.beVersion = res['oContent'] ?? '';
			this.appVersion = version;
			const dialogRef = this.dialog.open(AppInfoComponent, {
				data: {
					title: 'DDT Application Information',
					content: `Web application version: ` + this.appVersion,
					content2: `Server application version: ` + this.beVersion,
					confirmButtonLabel: 'Refresh all & Close',
					confirmButtonColor: 'basic',
					cancelButtonLabel: 'Close',
					cancelButtonColor: 'accent'
				}
			});

			dialogRef.afterClosed().subscribe((res) =>
			{
				if (res && res == true)
				{
					localStorage.clear();
					window.location.reload();
				}
			});
		})
		 */

		// dialog info creation
		const dialogRef = this.dialog.open(AppInfoComponent, {
			data: {
				title: this.appName,
				content: this.appVersion,
				content2: this.beVersion,
				confirmButtonLabel: 'Refresh all & Close',
				confirmButtonColor: 'basic',
				cancelButtonLabel: 'Close',
				cancelButtonColor: 'accent'
			}
		});

		// dialog closed event
		dialogRef.afterClosed().subscribe((res) =>
		{
			if (res && res == true)
			{
				localStorage.clear();
				window.location.reload();
			}
		});
	}

	// provide applications logs
	downloadLog()
	{
		// const data = JSON.parse(sessionStorage.getItem('httpLog') ?? '')
		// const fileName = 'download_' + Date.now()
		// const exportType = exportFromJSON.types.json
		// exportFromJSON({data, fileName, exportType})
		this.cs.getAppInfo().provideLogs();
	}

	refreshAll()
	{
		localStorage.clear();
		window.location.reload();
	}

	// switchLang(lang: string)
	// {
	// 	this.translate.use(lang);
	// localStorage.setItem('lang', lang);
	// }

	onRoleChange(event: any)
	{
		/*
		if (this.role)
		{
			this.authService.setUserRole(this.role).subscribe(res =>
			{
				localStorage.removeItem('layout');
				localStorage.removeItem('filter');
				Object.keys(sessionStorage).forEach(function (key)
				{
					if (!key.startsWith("sort"))
					{
						sessionStorage.removeItem(key)
					}
				});
				window.location.reload();
			});
		}
		 */

		if (this.role != undefined)
		{
			let lastRoleId: string = "";

			// get last role set
			this.cs.getAuthService().getUserRoleObs().subscribe( value => {
				lastRoleId= value;
			});

			if (lastRoleId != this.role)
			{
				// role needs to be updated
				this.cs.getAuthService().setUserRoleObs(this.role).subscribe( status => {

					if ( status )
					{
						// operation was successful

						// localStorage.removeItem('layout');
						// localStorage.removeItem('filter');
						//
						// Object.keys(sessionStorage).forEach(function (key)
						// {
						// 	if (!key.startsWith("sort"))
						// 	{
						// 		sessionStorage.removeItem(key)
						// 	}
						// });
						// DANGER: the following will cause window reloads and another call of ngOnInit() and
						//         'custom-select' will emit 'onRoleChange' event again, that may cause an infinite loop
						//         depending on order values involved are initialized !!!
						//window.location.reload();

						// invoke application provided handler on change of user role
						this.cs.getAuthService().changeUserRoleHandler();
					};

				});
			}
		}
	} // onChangeRole()

}
